import { render, staticRenderFns } from "./ReportAgingCH.vue?vue&type=template&id=0180a262"
import script from "./ReportAgingCH.vue?vue&type=script&lang=js"
export * from "./ReportAgingCH.vue?vue&type=script&lang=js"
import style0 from "./ReportAgingCH.vue?vue&type=style&index=0&id=0180a262&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports